import React, {useState, useMemo} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './ReadMore.module.scss';

const cx = classnames.bind(styles);

const ReadMore = (props) => {
  const {
    text,
    length,
    btnMoreText,
    btnLessText,
    className,
    tag: Tag,
    ...otherProps
  } = props;
  const [isCutted, setIsCutted] = useState(text.length > length)

  const btnText = useMemo(function () {
    if (text?.length < length) return null;
    return isCutted ? btnMoreText : btnLessText;
  }, [isCutted, btnMoreText, btnLessText, text, length])

  return (
    <div className={className} {...otherProps}>
      <Tag className={cx('text', {'cutted': isCutted})}>{text}</Tag>
      {btnText && (
        <button type="button" className={cx('button')} onClick={() => setIsCutted(!isCutted)}>{btnText}</button>
      )}
    </div>
  )
}

ReadMore.propTypes = {
  text: PropTypes.string.isRequired,
  length: PropTypes.number,
  btnMoreText: PropTypes.string,
  btnLessText: PropTypes.string,
  className: PropTypes.string,
  tag: PropTypes.oneOf(['p', 'div', 'h1', 'h2', 'h3', 'h4']),
}

ReadMore.defaultProps = {
  btnMoreText: 'Read more...',
  btnLessText: 'Show less',
  length: 110,
  className: null,
  tag: 'p',
}

export default ReadMore;
